import { ACTIONS } from 'tracker.constants';

export function savePrivatePackageTracker({
  privatePackageTracker,
  pathname = ''
}) {
  return {
    type: ACTIONS.SAVE_PRIVATE_PACKAGE,
    data: {
      privatePackageTracker,
      pathname
    }
  };
}

export function saveNewPackageAddress({
  addressData = false,
  newDestinationInfo = null,
  newComplement = null
}) {
  return {
    type: ACTIONS.SAVE_NEW_DESTINATION_INFO,
    addressData,
    newDestinationInfo,
    newComplement
  };
}

export function savePhoneNumber({
  mobilePhoneNumber,
  isMobilePhoneNumberAlreadyVerified,
  packageTracker,
  shouldLoadQuery
}) {
  return {
    type: ACTIONS.SAVE_PHONE_NUMBER,
    mobilePhoneNumber,
    isMobilePhoneNumberAlreadyVerified,
    packageTracker,
    shouldLoadQuery
  };
}

export function saveScreenFlow({ hasFinishedScreenFlow = false }) {
  return {
    type: ACTIONS.SAVE_HAS_FINISHED_SCREEN_FLOW,
    hasFinishedScreenFlow
  };
}
